// catogory head asst top

export const AboutData = [
	{
		id: 2,
		category: "top",
		post: "Chairperson",
		name: "Bhalchandra Palsamkar",
		instagram: "https://instagram.com/palsamkar_bhalchandra_16?igshid=OGQ5ZDc2ODk2ZA==",
		linkdin: "https://www.linkedin.com/in/bhalchandra-palsamkar-356a0928b",
		img: "img/bhalchandra.jpg",
	},
	{
		id: 3,
		category: "top",
		post: "Vice Chairperson",
		name: "Chaitanya Dandekar",
		instagram: "https://instagram.com/chaitanyadan31?igshid=MzRlODBiNWFlZA==",
		linkdin: "https://www.linkedin.com/in/chaitanya-dandekar-5081bb292",
		img: "/committe/chaitanya.png",
	},
	{
		id: 4,
		category: "top",
		post: "Secretary",
		name: "Pranjal Zende",
		instagram: "https://instagram.com/__pranjallll__?igshid=YTQwZjQ0NmI0OA==",
		linkdin: "https://www.linkedin.com/in/pranjal-zende-51473425b",
		img: "/committe/pranjal.png",
	},
	{
		id: 4,
		category: "top",
		post: "treasurer",
		name: "Om padhi",
		instagram: "https://instagram.com/__pranjallll__?igshid=YTQwZjQ0NmI0OA==",
		linkdin: "https://www.linkedin.com/in/pranjal-zende-51473425b",
		img: "/committe/om.png",
	},
	{
		id: 5,
		category: "head",
		post: "Event Coordinator",
		name: "Ashlesha More",
		instagram: "https://instagram.com/ashlesha_moree?igshid=YTQwZjQ0NmI0OA==",
		linkdin: "https://www.linkedin.com/in/ashlesha-more-02a853253",
		img: "/committe/ashlesha.png",
	},
	{
		id: 6,
		category: "head",
		post: "Marketing",
		name: "Aastha Pimple",
		instagram: "https://instagram.com/aastha018_?igshid=MzMyNGUyNmU2YQ==",
		linkdin: "https://www.linkedin.com/in/aastha-pimple-387917261",
		img: "/committe/aastha.png",
	},
	{
		id: 7,
		category: "head",
		post: "Technical",
		name: "Prerak gada",
		instagram: "https://www.instagram.com/prerakgada/",
		linkdin: "https://www.linkedin.com/in/prerakgada",
		img: "/committe/prerak.png",
	},
	{
		id: 8,
		category: "head",
		post: "Technical",
		name: "KHYATI NALAWADE",
		instagram: "https://instagram.com/khyati____19?igshid=NGVhN2U2NjQ0Yg==",
		linkdin: "www.linkedin.com/in/khyati-nalawade-72190b268",
		img: "/committe/khyati.png",
	},
	{
		id: 9,
		category: "head",
		post: "Registration",
		name: "HARSH NIKHARGE",
		instagram: "https://instagram.com/nikhargeharsh?igshid=ZGUzMzM3NWJiOQ==",
		linkdin: "",
		img: "/committe/harsh.png",
	},
	{
		id: 10,
		category: "head",
		post: "Publicity",
		name: "Saakshi Wakode",
		instagram: "https://instagram.com/saakkshhhiiii?igshid=YTQwZjQ0NmI0OA==",
		linkdin: "https://www.linkedin.com/in/saakshi-wakode-49839425a",
		img: "/committe/sakshi.png",
	},
	{
		id: 11,
		category: "head",
		post: "Creative",
		name: " SUJIT GIRI",
		instagram: "https://instagram.com/___giri___sujit___?igshid=OGQ5ZDc2ODk2ZA==",
		linkdin: "https://www.linkedin.com/in/sujit-giri-3bb089210",
		img: "/committe/sujit.png",
	},
	{
		id: 12,
		category: "asst",
		post: "Event Coordinator",
		name: "NISHCHAY SANTOSH RAORANE ",
		instagram: "https://instagram.com/ognishchayraorane?igshid=NGVhN2U2NjQ0Yg==",
		linkdin: "https://www.linkedin.com/in/nishchay-raorane-485138284",
		img: "/committe/nishchay.png",
	},
	{
		id: 15,
		category: "asst",
		post: "Marketing",
		name: "GAURAV SHUKLA",
		instagram: "https://instagram.com/gaurav__shukla07?igshid=YTQwZjQ0NmI0OA==",
		linkdin: "",
		img: "/committe/shukla.png",
	},
	{
		id: 15,
		category: "asst",
		post: "Marketing",
		name: "Anuj Chavan",
		instagram: "https://instagram.com/anuj_chavan_13?utm_source=qr&igshid=MThlNWY1MzQwNA==",
		linkdin: "https://www.linkedin.com/in/anuj-chavan-907121216",
		img: "/committe/anuj.png",
	},
	{
		id: 17,
		category: "asst",
		post: "Marketing",
		name: "ANIKET LASE",
		instagram: "https://instagram.com/aniketlase_?igshid=YTQwZjQ0NmI0OA==",
		linkdin: "http://linkedin.com/in/aniket-lase-017966218",
		img: "/committe/aniket.png",
	},
	{
		id: 17,
		category: "asst",
		post: "Technical",
		name: "VIVEK YADAV ",
		instagram: "https://instagram.com/pvt.vivek_69?igshid=OGQ5ZDc2ODk2ZA==",
		linkdin: "https://www.linkedin.com/in/vivek-yadav-4060ba246",
		img: "/committe/vivek.png",
	},
	{
		id: 17,
		category: "asst",
		post: "Technical",
		name: "Anand Subramani",
		instagram: "https://instagram.com/anand_s_7710?igshid=MzMyNGUyNmU2YQ==",
		linkdin: "https://www.linkedin.com/in/vivek-yadav-4060ba246",
		img: "/committe/aanand.png",
	},
	{
		id: 17,
		category: "asst",
		post: "Technical",
		name: "Yash Surve",
		instagram: "https://www.instagram.com/yash.ioi.7/",
		linkdin: "https://www.linkedin.com/in/yash-surve-244414255/",
		img: "/committe/yash.png",
	},
	{
		id: 18,
		category: "asst",
		post: "Registration",
		name: "VEDANT SHANKAR REDDY",
		instagram: "https://instagram.com/vedant17644?igshid=NzZlODBkYWE4Ng==",
		linkdin: "https://www.linkedin.com/in/vedant-reddy-330120253",
		img: "/committe/vedant.png",
	},
	{
		id: 18,
		category: "asst",
		post: "Registration",
		name: " YASH INGALE",
		instagram: "https://instagram.com/__yashhingale?igshid=NzZlODBkYWE4Ng==",
		linkdin: "https://www.linkedin.com/in/yashh-ingale-933a96279",
		img: "/committe/ingale.png",
	},
	{
		id: 19,
		category: "asst",
		post: "Registration",
		name: "JIDNYESHA SANKHE",
		instagram: "https://instagram.com/sankhejidnyesha?igshid=ZGUzMzM3NWJiOQ==",
		linkdin: "https://www.linkedin.com/in/jidnyesha-sankhe-6599b5289",
		img: "/committe/jid.png",
	},
	{
		id: 20,
		category: "asst",
		post: "Pubilicity",
		name: " Avaneesh Gaykar",
		instagram: "https://www.instagram.com/__avxnish__/",
		linkdin: "https://www.linkedin.com/in/avaneesh-gaykar-667627292/",
		img: "/committe/avneesh.png",
	},
	{
		id: 21,
		category: "asst",
		post: "Pubilicity",
		name: "Shruti Mahesh Angre",
		instagram: "https://instagram.com/shruti.angre?igshid=OGQ5ZDc2ODk2ZA==",
		linkdin: "https://www.linkedin.com/in/shruti-angre-5a0a03243",
		img: "/committe/shruti.png",
	},
	{
		id: 22,
		category: "asst",
		post: "Creative",
		name: "sashmit poojary",
		instagram: "https://instagram.com/sashmit_poojary?igshid=OGQ5ZDc2ODk2ZA==",
		linkdin: "https://www.linkedin.com/in/sashmit-poojary-460822262",
		img: "/committe/sashmit.png",
	},
	{
		id: 24,
		category: "asst",
		post: "Creative",
		name: "Kedar Khamkar",
		instagram: "https://www.instagram.com/_kedar07/",
		linkdin: "",
		img: "img/Kedar Khamkar _Assitant Creative Head -min.jpg",
	},
	{
		id: 25,
		category: "asst",
		post: "Web Master",
		name: " AKSHAY MANJREKAR",
		instagram: "https://instagram.com/a_manjrekar_?igshid=YTQwZjQ0NmI0OA==",
		linkdin: "https://www.linkedin.com/in/akshay-manjrekar",
		img: "/committe/akshay.png",
	},
	{
		id: 26,
		category: "asst",
		post: "Digital Creative",
		name: "Chinmaye Bidaye",
		instagram: "https://www.instagram.com/_chinmayeeeeee/",
		linkdin: "",
		img: "img/Chinmayee Bidaye_Asst. Digital Creative Head-min.jpg",
	},
	{
		id: 27,
		category: "asst",
		post: "Web Master",
		name: "KHALIL PATHAN",
		instagram: "https://instagram.com/khalil_pathan786?igshid=NTc4MTIwNjQ2YQ==",
		linkdin:
			"www.linkedin.com/in/khalil-pathan-429751292",
		img: "/committe/kh.png",
	},
	{
		id: 27,
		category: "asst",
		post: "Elite guest management",
		name: "Gaurav pimpale",
		instagram: "https://instagram.com/_gaurav_pimpale_?igshid=NGVhN2U2NjQ0Yg==",
		linkdin:
			"https://www.linkedin.com/in/gaurav-pimpale-475861250",
		img: "/committe/gaurav.png",
	},
	{
		id: 27,
		category: "asst",
		post: "Web Master",
		name: "Prince Singh",
		instagram: "https://instagram.com/41ph9?igshid=NjIwNzIyMDk2Mg==",
		linkdin:
			"https://www.linkedin.com/in/prince-singh-bb2501292",
		img: "/committe/prince.png",
	},
];
